export var ModalWidthOptions;
(function (ModalWidthOptions) {
    ModalWidthOptions["Narrow"] = "narrow";
    ModalWidthOptions["Wide"] = "wide";
})(ModalWidthOptions || (ModalWidthOptions = {}));
export var ModalContentSize;
(function (ModalContentSize) {
    ModalContentSize["FullScreen"] = "fullScreen";
    ModalContentSize["HalfScreen"] = "halfScreen";
})(ModalContentSize || (ModalContentSize = {}));
export var ModalContentPosition;
(function (ModalContentPosition) {
    ModalContentPosition["Center"] = "center";
    ModalContentPosition["Bottom"] = "bottom";
})(ModalContentPosition || (ModalContentPosition = {}));
